import * as React from 'react';

import { Select, Space } from 'antd';
import { useAtomValue } from 'jotai';
import {
	ResaLocation,
	allLocationsAtom,
	locationAtom,
	tbdLocationAtom,
} from '../store/location';
import { FormattedMessage } from 'react-intl';

export const LocationSelect = (props: {
	locationId?: number;
	onChange?: (id: number) => void;
}) => {
	const tbdLocation = useAtomValue(tbdLocationAtom);
	const allLocations = useAtomValue(allLocationsAtom);
	const currentLocation = useAtomValue(locationAtom(props.locationId ?? -1));

	return (
		<Select
			value={currentLocation?.post_title}
			onChange={(_, o) => props.onChange?.((o as ResaLocation).ID)}
			placeholder={
				<FormattedMessage defaultMessage="Selectionner un lieu" id="TWec1W" />
			}
			showSearch
			options={allLocations.concat(tbdLocation).map((l) => ({
				...l,
				label: l.post_title,
				value: l.post_title,
			}))}
			optionRender={(o) => {
				const l = o.data as ResaLocation;
				return <Space>{l.post_title}</Space>;
			}}
			filterOption={(input, o) =>
				o?.post_title.toLocaleLowerCase().includes(input.toLocaleLowerCase()) ??
				false
			}
		/>
	);
};
